import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Tag, Plus, Trash2 } from "lucide-react";

export default function PromoCodesCard({ rooms }) {
  const [promos, setPromos] = useState([]);
  const [form, setForm] = useState({ code: "", percent: 20, room_id: "", max_uses: "", expires_at: "" });
  const load = () => api.get("/promos").then((r) => setPromos(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    try {
      await api.post("/promos", {
        code: form.code, percent: Number(form.percent), room_id: form.room_id || null,
        max_uses: form.max_uses ? Number(form.max_uses) : null,
        expires_at: form.expires_at ? new Date(form.expires_at + "T23:59:59").toISOString() : null,
      });
      toast.success(`Code ${form.code.toUpperCase()} créé`);
      setForm({ code: "", percent: 20, room_id: "", max_uses: "", expires_at: "" }); load();
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || "Erreur"); }
  };
  const remove = async (p) => { await api.delete(`/promos/${p.id}`); toast.success("Code désactivé"); load(); };

  return (
    <div className="mt-8 sc-card" data-testid="promo-codes-card">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><Tag className="w-5 h-5 text-rose-500" /> Codes promo</h2>
      <p className="text-sm text-slate-600 mt-1">Remplissez vos créneaux creux : le coach ou le client saisit le code au moment de payer.</p>
      <div className="mt-3 grid sm:grid-cols-5 gap-2">
        <input data-testid="promo-code" placeholder="CODE (ex. MATIN20)" className="border border-slate-200 rounded-xl p-2 text-sm uppercase" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value.toUpperCase() })} />
        <input data-testid="promo-percent" type="number" min={5} max={100} placeholder="% réduction" className="border border-slate-200 rounded-xl p-2 text-sm" value={form.percent} onChange={(e) => setForm({ ...form, percent: e.target.value })} />
        <select data-testid="promo-room" className="border border-slate-200 rounded-xl p-2 text-sm" value={form.room_id} onChange={(e) => setForm({ ...form, room_id: e.target.value })}>
          <option value="">Toutes mes salles</option>
          {rooms.map((r) => <option key={r.id} value={r.id}>{r.name}</option>)}
        </select>
        <input data-testid="promo-max-uses" type="number" min={1} placeholder="Utilisations max" className="border border-slate-200 rounded-xl p-2 text-sm" value={form.max_uses} onChange={(e) => setForm({ ...form, max_uses: e.target.value })} />
        <input data-testid="promo-expires" type="date" className="border border-slate-200 rounded-xl p-2 text-sm" value={form.expires_at} onChange={(e) => setForm({ ...form, expires_at: e.target.value })} />
      </div>
      <div className="mt-2 flex justify-end"><button data-testid="promo-create" onClick={create} disabled={form.code.length < 3} className="sc-btn sc-btn-emerald text-sm disabled:opacity-50"><Plus className="w-4 h-4" /> Créer le code</button></div>
      <div className="mt-3 space-y-1.5" data-testid="promo-list">
        {promos.map((p) => (
          <div key={p.id} data-testid={`promo-${p.code}`} className={`flex items-center justify-between text-sm px-3 py-2 rounded-xl border ${p.active ? "border-slate-200" : "border-slate-100 opacity-50"}`}>
            <div className="flex items-center gap-3">
              <span className="font-mono font-bold text-rose-600">{p.code}</span>
              <span className="font-semibold">-{p.percent}%</span>
              <span className="text-xs text-slate-500">{p.room_id ? rooms.find((r) => r.id === p.room_id)?.name : "toutes salles"} · {p.uses}{p.max_uses ? `/${p.max_uses}` : ""} utilisation(s){p.expires_at ? ` · jusqu'au ${new Date(p.expires_at).toLocaleDateString("fr-FR")}` : ""}{!p.active ? " · désactivé" : ""}</span>
            </div>
            {p.active && <button data-testid={`promo-delete-${p.code}`} onClick={() => remove(p)} className="text-rose-600" aria-label="Désactiver"><Trash2 className="w-4 h-4" /></button>}
          </div>
        ))}
        {promos.length === 0 && <div className="text-sm text-slate-500">Aucun code pour le moment.</div>}
      </div>
    </div>
  );
}
